import { create } from 'zustand'

import { trackFeaturePaywallBlocked } from '@/components/common/feature-paywall/feature-paywall-dialog/feature-paywall-dialog.tracking'
import type { PlanType } from '@/lib/plans'
import { useContextStore } from '@/stores/context'

interface FeaturePaywallStore {
  isOpen: boolean
  feature: string | null
  minimumPlan: PlanType | null
  source: string | null
  showFeaturePaywall: (
    feature: string,
    minimumPlan?: PlanType,
    source?: string,
  ) => void
  hideFeaturePaywall: () => void
}

export const useFeaturePaywallStore = create<FeaturePaywallStore>((set) => ({
  isOpen: false,
  feature: null,
  minimumPlan: null,
  source: null,
  showFeaturePaywall: (feature, minimumPlan, source) => {
    // Emitted here (not in useFeaturePaywall.requireAccess) so every path that
    // opens the paywall — including direct store calls like the document/signer
    // count gates — produces the Blocked event that lifecycle workflows key on.
    trackFeaturePaywallBlocked({
      feature,
      minimumPlan: minimumPlan ?? null,
      currentPlan:
        useContextStore.getState().userAccountContext?.balanceInformation
          .featureType ?? 'Free',
      source: source ?? null,
    })
    set({
      isOpen: true,
      feature,
      minimumPlan: minimumPlan ?? null,
      source: source ?? null,
    })
  },
  hideFeaturePaywall: () =>
    set({
      isOpen: false,
      feature: null,
      minimumPlan: null,
      source: null,
    }),
}))
